import { paymentModalNames } from 'client/GrowthEngineering/utilities/GrowthConstants';
import EventHelper from 'client/GrowthEngineering/EventHelper';
import EventManager from 'client/GrowthEngineering/EventManager';
import ModalEventBus from 'components/Modal/ModalEventBus';
import PaymentModal from 'client/Payments/PaymentModal.vue';

export default {
  openPaymentModal(source) {
    EventManager.triggerPaymentModalViewed({ modal: paymentModalNames.paymentSetup, source });
    ModalEventBus.open({
      component: PaymentModal,
      isLargeModal: true,
      preventCloseOnOverlayClick: true,
    });
  },

  openCheckoutModal(source) {
    EventManager.triggerPaymentModalViewed({ modal: paymentModalNames.paymentIntroModal, source });
    ModalEventBus.open({
      component: PaymentModal,
      componentProps: {
        showUserLimitWarning: true,
        source,
      },
      isFullScreenModal: true,
      preventCloseOnOverlayClick: true,
    });
  },

  openPaymentModalForProvider() {
    EventHelper.triggerProviderPaymentModalViewed();
    ModalEventBus.open({
      component: PaymentModal,
      isLargeModal: true,
      preventCloseOnOverlayClick: true,
    });
  },

  openPaymentInformationForClosedCustomer(source) {
    EventHelper.triggerModalViewed({ modal: paymentModalNames.paymentInfoForNoCCModal, source });
    ModalEventBus.open({
      component: PaymentModal,
      isLargeModal: true,
      preventCloseOnOverlayClick: true,
      componentProps: {
        hasCreditCardOnFile: false,
      },
    });
  },
};
